import { ComponentProps, PropsWithChildren } from "react";
import styled from "styled-components";
import {
  semanticBackgroundBase,
  semanticPrimaryBgHover,
  semanticPrimaryText,
  semanticTextNormal,
  spacingXlarge,
} from "@songtradr/component-library";

// TEXT

// STYLES
export const Container = styled.div`
  position: relative;
  top: -3px;
  margin-left: ${spacingXlarge};
`;

export const Checkbox = styled.span`
  transition: all 0.2s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: ${semanticBackgroundBase};
  border: 1px solid ${semanticTextNormal};
  border-radius: 4px;

  &:after {
    content: "";
    position: absolute;
    display: none;

    left: 5px;
    top: 1px;
    width: 7px;
    height: 14px;
    border: solid ${semanticBackgroundBase};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ ${Checkbox} {
    border-color: ${semanticPrimaryText};
    background-color: ${semanticPrimaryText};

    &:after {
      display: block;
    }
  }
`;

export const Label = styled.label`
  position: relative;
  cursor: pointer;

  &:hover {
    ${Input}:checked ~ ${Checkbox} {
      background-color: ${semanticPrimaryBgHover};
    }

    ${Checkbox} {
      border-color: ${semanticPrimaryText};
    }
  }
`;

// DATA

// TYPES
export type Props = PropsWithChildren<ComponentProps<"input">>;

// CONSTANTS

// FUNCTIONS

// ASSETS
